import { render, staticRenderFns } from "./StandardLeft.vue?vue&type=template&id=bf1f5c76&"
import script from "./StandardLeft.vue?vue&type=script&lang=js&"
export * from "./StandardLeft.vue?vue&type=script&lang=js&"
import style0 from "./StandardLeft.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports